import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Gasdata from '../entities/gasdata'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface GasdataState extends ListState<Gasdata>{
    analyseGasdata: Gasdata
}
class UserMutations extends ListMutations<Gasdata>{

}
class GasdataModule extends ListModule<GasdataState,any,Gasdata>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        analyseGasdata:new Gasdata(),
        list: new Array<Gasdata>(),
        loading:false,
        editGasdata:new Gasdata()
    }
    actions={
        async getAllPaged(context:ActionContext<GasdataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Gasdata/GetAllPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gasdata>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getPagedLast(context: ActionContext<GasdataState, any>, payload: any) {
            // context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Gasdata/GetPagedLast', { params: payload.data });
            // context.state.loading = false;
            let page = reponse.data.result as PageResult<Gasdata>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items;
            return page.items;
        },
        // async getWarningPaged(context:ActionContext<GasdataState,any>,payload:any){
          
        //     context.state.loading=true;
        //     let reponse=await Ajax.get('/api/services/app/Gasdata/GetWarningPaged',{params:payload.data});
        //     context.state.loading=false;
        //     let page=reponse.data.result as PageResult<Gasdata>;
        //     context.state.totalCount=page.totalCount;
        //     context.state.list=page.items;
        // },
        // async getWareHouseList(context:ActionContext<GasdataState,any>,payload:any){
          
        //     context.state.loading=true;
        //     let reponse=await Ajax.get('/api/services/app/Gasdata/GetWareHouseList',{params:payload.data});
        //     context.state.loading=false;
        //     let page=reponse.data.result as PageResult<Gasdata>;
        //     context.state.totalCount=page.totalCount;
        //     context.state.list=page.items;
        //     return 1;
        // },
        async getPaged(context:ActionContext<GasdataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Gasdata/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gasdata>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<GasdataState,any>,payload:any){
            await Ajax.post('/api/services/app/Gasdata/Create',payload.data);
        },
        async update(context:ActionContext<GasdataState,any>,payload:any){
            await Ajax.put('/api/services/app/Gasdata/Update',payload.data);
        },
        async delete(context:ActionContext<GasdataState,any>,payload:any){
            await Ajax.delete('/api/services/app/Gasdata/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<GasdataState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Gasdata/GetById?Id='+payload.id);
            return reponse.data.result as Gasdata;
        },
        async getPageByDate(context: ActionContext<GasdataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Gasdata/GetPageByDate', { params: payload.data });
            let page = reponse.data.result as PageResult<Gasdata>;
            return page.items;
        }
        // async getWarning(context:ActionContext<GasdataState,any>,payload:any){
        //     let reponse=await Ajax.get('/api/services/app/Gasdata/GetWarningList');
        //     return reponse.data.result.items;
        // },
        // async getRank(context:ActionContext<GasdataState,any>,payload:any){
        //     let reponse=await Ajax.get('/api/services/app/Gasdata/GetRankList?day='+payload.data);
        //     return reponse.data.result.items;
        // }

    };
    mutations={
        setCurrentPage(state:GasdataState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:GasdataState,pagesize:number){
            state.pageSize=pagesize;
        },
        analyse(state: GasdataState, gasdata: Gasdata) {
            state.analyseGasdata = gasdata;
        },
    }
}
const gasdataModule=new GasdataModule();
export default gasdataModule;